import React, { Component } from "react";

const AppContext = React.createContext({QUIZ:null});

export default AppContext;